import { message } from "antd";

/**
 * Three-way toast for bulk action results.
 * - success when every item updated
 * - warning on partial success
 * - error when nothing updated
 */
export function bulkActionToast(updatedCount: number, totalCount: number, summary: string): void {
    const text = `${updatedCount} of ${totalCount} ${summary}`;

    if (updatedCount === totalCount && updatedCount > 0) {
        void message.success(text);
        return;
    }

    if (updatedCount > 0) {
        void message.warning(text);
        return;
    }

    void message.error(text);
}
